<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-xl-8">
          <div class="row g-2 align-items-center">
            <div class="col-12 col-md-4">
              <h5 class="card-title mb-0">{{ 'weeklySchedule' | translate }}</h5>
              <h6 class="card-subtitle text-muted mt-1">{{ 'adjustWeeklySchedule' | translate }}</h6>
            </div>

            <div class="col-12 col-md-4 d-flex justify-content-md-center">
              <div class="d-flex align-items-center gap-3 flex-wrap justify-content-center">
                <app-out-buttons [numOutputs]="outputCount" (outputChange)="onOutputChange($event)"></app-out-buttons>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-4 d-flex justify-content-center justify-content-xl-end">
          <div class="btn-group btn-group-sm" role="group" [attr.aria-label]="'viewMode' | translate">
            <button type="button" class="btn" (click)="viewMode = 'scheduler'"
              [ngClass]="viewMode === 'scheduler' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'programs' | translate }}
            </button>
            <button type="button" class="btn" (click)="viewMode = 'holiday'"
              [ngClass]="viewMode === 'holiday' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'periods' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pt-0">
      <form>
        <div class="row g-3 align-items-stretch">
          <div class="col-12">
            <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3 mt-1 w-100">
              <div class="d-flex align-items-center gap-2 ms-4">
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="shiftSunDate(-1)" [title]="'previousDay' | translate">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  style="max-width: 150px;"
                  [(ngModel)]="selectedSunDate"
                  (change)="onSunDateChange()">
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="shiftSunDate(1)" [title]="'nextDay' | translate">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
                <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="goToTodaySunDate()" [title]="'today' | translate">
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
              </div>

              <div class="d-flex align-items-center flex-wrap gap-2 ms-lg-auto">
                <div class="d-inline-flex align-items-center gap-2 px-2 py-2 border rounded-3 bg-white shadow-sm">
                  <div class="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary"
                    style="width: 30px; height: 30px;">
                    <i class="fa-regular fa-clock small"></i>
                  </div>
                  <div class="d-flex flex-column lh-sm">
                    <small class="text-muted text-center">{{ 'dlTodayRelayLabel' | translate:{ channel: selectedOutput } }}</small>
                    <span class="fw-semibold text-dark">{{ todayHours }} h <small class="text-muted fw-normal">{{ 'operatingHours' | translate }}</small></span>
                  </div>
                </div>
                <div class="d-inline-flex align-items-center gap-2 px-2 py-2 border rounded-3 bg-white shadow-sm">
                  <div class="d-flex align-items-center justify-content-center rounded-circle bg-secondary bg-opacity-10 text-secondary"
                    style="width: 30px; height: 30px;">
                    <i class="fa-regular fa-calendar-days small"></i>
                  </div>
                  <div class="d-flex flex-column lh-sm">
                    <small class="text-muted text-center">{{ 'dlAnnualRelayLabel' | translate:{ channel: selectedOutput } }}</small>
                    <span class="fw-semibold text-dark">{{ annualHours }} h <small class="text-muted fw-normal">{{ 'operatingHours' | translate }}</small></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-6 d-flex flex-column mt-0">
            <div class="py-2 flex-fill">
              <app-scheduler-anc
                [schedulerData]="scheduleData"
                [outputCount]="outputCount"
                [selectedOutput]="selectedOutput"
                [sunTimesData]="sunTimesData"
                [showLegend]="false"
                [serial]="device"
                [HolidayData]="holidayData"
                [hoveredProgramId]="hoveredProgramId"
                [dlPrograms]="activePrograms"
                [dlActiveFestive]="todayPeriod?.periodIndex ?? 0"
                (schedulerDragChange)="onSchedulerDragChange($event)"
                chartIdPrefix="chart-dl">
              </app-scheduler-anc>
            </div>
          </div>

          <div class="col-12 col-xl-6 d-flex flex-column mt-0">
            <div *ngIf="viewMode === 'holiday'">
              <div class="border rounded-2 mt-4 p-3 w-100 flex-fill d-flex flex-column">
                <div class="d-flex align-items-center justify-content-center gap-2 pb-3"
                  [ngClass]="holidayData && holidayData.periods && holidayData.periods.length > 0 ? 'flex-grow-1' : 'mb-3'">
                  <div *ngIf="holidayData?.periods && holidayEnable" class="text-muted small mb-0">
                    {{ 'holidayClickCalendarHint' | translate }}
                  </div>

                  <button *ngIf="holidayEnable" type="button" class="btn btn-link p-0 text-primary"
                    (click)="openCalendarModal()" [attr.aria-label]="'openCalendar' | translate" [title]="'openCalendar' | translate">
                    <i class="fa-solid fa-calendar-days fs-4"></i>
                  </button>
                </div>

                <div [ngClass]="holidayData && holidayData.periods.length > 0 ? 'mt-auto' : ''">
                  <ng-container *ngIf="holidayData && holidayData?.periods?.length > 0; else emptyState">
                    <div class="d-flex flex-column gap-2">
                      <ng-container *ngFor="let period of holidayData.periods; let i = index">
                        <button type="button" *ngIf="period.enable"
                          class="btn text-start p-3 rounded-3 border d-flex align-items-center gap-3">
                          <div class="d-flex align-items-center justify-content-center rounded-circle text-white flex-shrink-0 lh-1 shadow-sm border border-white"
                            [ngClass]="i === 0 ? 'bg-primary' : i === 1 ? 'bg-success' : i === 2 ? 'bg-danger' : 'bg-secondary'"
                            style="width: 1.75rem; height: 1.75rem; font-size: 0.8rem;"
                            [attr.aria-label]="('holidayPeriod' | translate) + ' ' + (i + 1)">
                            <span class="fw-semibold">{{ i + 1 }}</span>
                          </div>

                          <div class="flex-grow-1">
                            <div class="fw-semibold text-dark">{{ 'holidayPeriod' | translate }} {{ i + 1 }}</div>
                            <div class="text-muted small">
                              {{ period.startDay }}/{{ period.startMonth }} · {{ period.startHourStr }}
                              →
                              {{ period.endDay }}/{{ period.endMonth }} · {{ period.endHourStr }}
                            </div>
                          </div>

                          <div class="d-flex gap-2">
                            <i class="fa-solid fa-pen-to-square" (click)="openCalendarModal(i); changesHoliday = true;"></i>
                            <i class="fa-solid fa-trash text-danger" (click)="deletePeriod(i);"></i>
                          </div>
                        </button>
                      </ng-container>

                      <button type="button" (click)="addPeriod()"
                        class="btn btn-outline-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                        style="border-style: dashed;">
                        <i class="fa-solid fa-plus"></i>
                        <span>{{ 'addPeriod' | translate }}</span>
                      </button>
                    </div>
                  </ng-container>

                  <ng-template #emptyState>
                    <div class="d-flex flex-column align-items-center text-center text-muted mb-3 pb-5">
                      <i class="fa-solid fa-calendar-days fs-2 mb-2"></i>
                      <div class="small">{{ 'noHolidayPeriodsActive' | translate }}</div>
                    </div>
                    <button type="button" (click)="addPeriod()"
                      class="btn btn-outline-secondary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                      style="border-style: dashed;">
                      <i class="fa-solid fa-plus"></i>
                      <span>{{ 'addPeriod' | translate }}</span>
                    </button>
                  </ng-template>

                  <div>
                    <div class="mt-auto mb-4 d-flex justify-content-end gap-2">
                      <button type="button" [disabled]="!changesHoliday"
                        class="col-6 mt-4 btn btn-light d-inline-flex align-items-center justify-content-center"
                        (click)="restoreHoliday()">
                        <span>{{ 'restore' | translate }}</span>
                      </button>

                      <button type="button" [disabled]="!changesHoliday"
                        class="col-6 mt-4 btn btn-primary d-inline-flex align-items-center justify-content-center"
                        (click)="saveHoliday()">
                        <span class="spinner-border spinner-border-sm text-white me-2" role="status" *ngIf="loading">
                          <span class="visually-hidden">{{ 'loading' | translate }}</span>
                        </span>
                        <span>{{ 'save' | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="viewMode === 'scheduler'" class="flex-fill d-flex flex-column">
              <div class="table-responsive mt-3 pt-3">
                <table class="table table-sm table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th class="text-nowrap">#</th>
                      <th class="text-nowrap">{{ 'channel' | translate }}</th>
                      <th class="text-nowrap">{{ 'type' | translate }}</th>
                      <th class="text-nowrap" colspan="2">{{ 'schedule' | translate }}</th>
                      <th class="text-nowrap">{{ 'period' | translate }}</th>
                      <th class="text-nowrap">{{ 'action' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="programDataFormated.length === 0">
                      <td colspan="7">
                        <div class="py-4 text-center text-muted">
                          <i class="fa-solid fa-list-check fs-2 d-block mb-2"></i>
                          <div class="fw-semibold">{{ 'programsEmpty' | translate }}</div>
                          <div class="small">{{ 'programsAddHint' | translate }}</div>
                        </div>
                      </td>
                    </tr>

                    <tr *ngFor="let item of programDataFormated; let i = index"
                      [class.table-drag-updated]="highlightedProgramIndex === i"
                      [class.table-program-edited]="isProgramEdited(item.id)"
                      (mouseenter)="onProgramRowEnter(item)"
                      (mouseleave)="onProgramRowLeave()">

                      <ng-container *ngIf="item.id !== -1">
                        <td class="text-nowrap">
                          <span>{{ item.id + 1 }}</span>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ getChannelLabel(item.channel) }}</div>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ getKindLabel(item.kind) }}</div>
                        </td>

                        <td colspan="2" class="dl-schedule-cell">
                          <div class="dl-schedule-card">
                            <ng-container [ngSwitch]="item.kind">
                              <div *ngSwitchCase="'cycle'" class="dl-schedule-compact dl-schedule-compact--cycle">
                                <div class="dl-schedule-compact__segment dl-schedule-compact__segment--start">
                                  <i class="fa-solid fa-play fa-xs text-primary" [attr.title]="'programCycleStartTime' | translate"></i>
                                  <span class="dl-schedule-compact__time">{{ item.timeStr }}</span>
                                  <div class="dl-schedule-compact__days">
                                    <span *ngFor="let day of daysOfWeek" class="badge rounded-pill dl-day-badge"
                                      [ngClass]="isDaySelected(item.daymask, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                                      [attr.title]="getDayLabel(day.index)">{{ day.short }}</span>
                                  </div>
                                  <span class="dl-schedule-param dl-schedule-param--on">
                                    {{ 'on' | translate }} {{ getDurationLabel(item.cycleOnSeconds) }}
                                  </span>
                                </div>
                                <div class="dl-schedule-compact__segment dl-schedule-compact__segment--end">
                                  <i class="fa-solid fa-stop fa-xs text-secondary" [attr.title]="'programCycleEndTime' | translate"></i>
                                  <span class="dl-schedule-compact__time">{{ item.endTimeStr }}</span>
                                  <div class="dl-schedule-compact__days">
                                    <span *ngFor="let day of daysOfWeek" class="badge rounded-pill dl-day-badge"
                                      [ngClass]="isDaySelected(item.cycleEndDaymask, day.value) ? 'bg-secondary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                                      [attr.title]="getDayLabel(day.index)">{{ day.short }}</span>
                                  </div>
                                  <span class="dl-schedule-param dl-schedule-param--off">
                                    {{ 'off' | translate }} {{ getDurationLabel(item.cycleOffSeconds) }}
                                  </span>
                                </div>
                              </div>

                              <div *ngSwitchCase="'pulse'" class="dl-schedule-compact">
                                <span class="dl-schedule-compact__time">{{ item.timeStr }}</span>
                                <div class="dl-schedule-compact__days">
                                  <span *ngFor="let day of daysOfWeek" class="badge rounded-pill dl-day-badge"
                                    [ngClass]="isDaySelected(item.daymask, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                                    [attr.title]="getDayLabel(day.index)">{{ day.short }}</span>
                                </div>
                                <span class="dl-schedule-param dl-schedule-param--pulse">
                                  {{ 'duration' | translate }} {{ getPulseDurationLabel(item.pulseDurationSeconds) }}
                                </span>
                              </div>

                              <div *ngSwitchDefault class="dl-schedule-compact">
                                <span class="dl-schedule-compact__time">{{ item.timeStr }}</span>
                                <div class="dl-schedule-compact__days">
                                  <span *ngFor="let day of daysOfWeek" class="badge rounded-pill dl-day-badge"
                                    [ngClass]="isDaySelected(item.daymask, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                                    [attr.title]="getDayLabel(day.index)">{{ day.short }}</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </td>

                        <td class="text-nowrap">
                          <div>{{ item.festive == 0 ? '-' : item.festive }}</div>
                        </td>

                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn btn-sm btn-link p-0 text-primary"
                              [attr.aria-label]="'editSchedule' | translate" [title]="'edit' | translate"
                              (click)="setEditProgramIndex(i); newProgram = false;" data-bs-toggle="modal"
                              data-bs-target="#editDlProgram">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-link p-0 text-danger" (click)="deleteProgram(i)"
                              [attr.aria-label]="'deleteScheduleAria' | translate" [title]="'delete' | translate">
                              <i class="fa-solid fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-end mt-3">
                  <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#editDlProgram"
                    (click)="addProgram(); newProgram = true;">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="mt-auto mb-4 d-flex justify-content-end gap-2">
                <button type="button" [disabled]="!changesProgram"
                  class="col-6 mt-4 btn btn-light d-inline-flex align-items-center justify-content-center"
                  (click)="restoreProgram()">
                  <span>{{ 'restore' | translate }}</span>
                </button>

                <button type="button" [disabled]="!changesProgram"
                  class="col-6 mt-4 btn btn-primary d-inline-flex align-items-center justify-content-center"
                  (click)="saveProgram()">
                  <span class="spinner-border spinner-border-sm text-white me-2" role="status" *ngIf="loading">
                    <span class="visually-hidden">{{ 'loading' | translate }}</span>
                  </span>
                  <span>{{ 'save' | translate }}</span>
                </button>
              </div>

              <div class="alert alert-danger alert-dismissible mt-3" role="alert" *ngIf="error != ''">
                <div class="alert-message">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  {{ error }}
                </div>
              </div>
              <div class="alert alert-success alert-dismissible mt-3" role="alert" *ngIf="successMessage">
                <div class="alert-message">
                  <i class="fas fa-check-circle me-2"></i>
                  {{ "updatedSuccesfully" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade edit-program-modal" id="editDlProgram" tabindex="-1" aria-labelledby="editDlProgramLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!newProgram" class="modal-title" id="editDlProgramLabel">
          {{ 'editProgramTitle' | translate:{ number: (editProgramIndex ?? 0) + 1 } }}
        </h5>
        <h5 *ngIf="newProgram" class="modal-title" id="editDlProgramLabel">{{ 'newProgramTitle' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'close' | translate"></button>
      </div>

      <div class="modal-body">
        <ng-container *ngIf="editProgramDraft as draft">
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <label class="form-label" for="editDlProgramType">{{ 'type' | translate }}</label>
              <select class="form-select" id="editDlProgramType" name="editDlProgramType" [(ngModel)]="draft.type"
                (ngModelChange)="onEditDraftTypeChange()">
                <option [ngValue]="0">{{ 'off' | translate }}</option>
                <option [ngValue]="1">{{ 'on' | translate }}</option>
                <option [ngValue]="2">{{ 'programKind_pulse' | translate }}</option>
                <option [ngValue]="3">{{ 'programKind_cycle' | translate }}</option>
              </select>
            </div>

            <div class="col-12 col-md-4">
              <label class="form-label" for="editDlProgramChannel">{{ 'channel' | translate }}</label>
              <select class="form-select" id="editDlProgramChannel" name="editDlProgramChannel"
                [(ngModel)]="draft.channel">
                <option [ngValue]="1">C1</option>
                <option *ngIf="outputCount > 1" [ngValue]="2">C2</option>
                <option *ngIf="outputCount > 1" [ngValue]="3">{{ 'channelBoth' | translate }}</option>
              </select>
            </div>

            <div class="col-12 col-md-4">
              <label class="form-label" for="editDlProgramPeriod">{{ 'period' | translate }}</label>
              <select class="form-select" id="editDlProgramPeriod" name="editDlProgramPeriod" [(ngModel)]="draft.festive">
                <option [ngValue]="0">-</option>
                <option [ngValue]="1">P1</option>
                <option [ngValue]="2">P2</option>
                <option [ngValue]="3">P3</option>
                <option [ngValue]="4">P4</option>
              </select>
            </div>

            <!-- Programación estándar (no ciclo) -->
            <ng-container *ngIf="draft.type !== 3">
              <div class="col-12">
                <div class="border rounded-3 p-3 bg-light bg-opacity-50">
                  <div class="dl-weekday-picker">
                    <label class="form-label dl-weekday-picker__label fw-semibold">{{ 'weekDays' | translate }}</label>
                    <div class="dl-weekday-picker__presets">
                      <button type="button"
                        class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                        (click)="setQuickPreset('weekdays')">
                        <i class="fas fa-briefcase"></i>
                        <span class="fw-semibold">{{ 'workdays' | translate }}</span>
                      </button>
                      <button type="button"
                        class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                        (click)="setQuickPreset('weekend')">
                        <i class="fas fa-bed"></i>
                        <span class="fw-semibold">{{ 'weekend' | translate }}</span>
                      </button>
                      <button type="button"
                        class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                        (click)="setQuickPreset('allDays')">
                        <i class="fas fa-calendar"></i>
                        <span class="fw-semibold">{{ 'allDays' | translate }}</span>
                      </button>
                    </div>
                    <div class="dl-weekday-picker__days">
                      <button *ngFor="let day of daysOfWeek" type="button"
                        class="btn rounded-circle d-inline-flex align-items-center justify-content-center p-0 dl-day-btn"
                        [ngClass]="isDaySelected(draft.daymask, day.value) ? 'btn-primary' : 'btn-outline-secondary'"
                        [attr.title]="getDayLabel(day.index)" (click)="toggleDay(draft, day.value)">
                        <span class="fw-semibold">{{ day.short }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <label class="form-label" for="editDlProgramStartTime">{{ 'initTime' | translate }}</label>
                <input type="time" class="form-control" id="editDlProgramStartTime" name="editDlProgramStartTime"
                  [(ngModel)]="draft.timeStr">
              </div>

              <div class="col-12 col-md-6" *ngIf="draft.type === 2">
                <label class="form-label" for="editDlProgramPulseDuration">{{ 'programPulseDuration' | translate }} {{ 'inSeconds' | translate }}</label>
                <input type="number" min="1" class="form-control" id="editDlProgramPulseDuration"
                  name="editDlProgramPulseDuration" [(ngModel)]="draft.pulseDurationSeconds">
              </div>
            </ng-container>

            <!-- Programación de ciclo: inicio y fin con hora + días agrupados -->
            <ng-container *ngIf="draft.type === 3">
              <div class="col-12 col-lg-6">
                <div class="dl-cycle-block dl-cycle-block--start h-100">
                  <div class="dl-cycle-block__header">
                    <i class="fa-solid fa-play"></i>
                    <span>{{ 'programCycleStartTime' | translate }}</span>
                  </div>
                  <div class="dl-cycle-block__body">
                    <label class="form-label" for="editDlProgramStartTime">{{ 'initTime' | translate }}</label>
                    <input type="time" class="form-control mb-3" id="editDlProgramStartTime" name="editDlProgramStartTime"
                      [(ngModel)]="draft.timeStr">

                    <label class="form-label">{{ 'weekDays' | translate }}</label>
                    <div class="dl-weekday-picker dl-weekday-picker--compact">
                      <div class="dl-weekday-picker__presets">
                        <button type="button"
                          class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('weekdays', 'start')">
                          <i class="fas fa-briefcase"></i>
                          <span class="fw-semibold">{{ 'workdays' | translate }}</span>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('weekend', 'start')">
                          <i class="fas fa-bed"></i>
                          <span class="fw-semibold">{{ 'weekend' | translate }}</span>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('allDays', 'start')">
                          <i class="fas fa-calendar"></i>
                          <span class="fw-semibold">{{ 'allDays' | translate }}</span>
                        </button>
                      </div>
                      <div class="dl-weekday-picker__days">
                        <button *ngFor="let day of daysOfWeek" type="button"
                          class="btn rounded-circle d-inline-flex align-items-center justify-content-center p-0 dl-day-btn"
                          [ngClass]="isDaySelected(draft.daymask, day.value) ? 'btn-primary' : 'btn-outline-secondary'"
                          [attr.title]="getDayLabel(day.index)" (click)="toggleDay(draft, day.value)">
                          <span class="fw-semibold">{{ day.short }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div class="dl-cycle-block dl-cycle-block--end h-100">
                  <div class="dl-cycle-block__header">
                    <i class="fa-solid fa-stop"></i>
                    <span>{{ 'programCycleEndTime' | translate }}</span>
                  </div>
                  <div class="dl-cycle-block__body">
                    <label class="form-label" for="editDlProgramEndTime">{{ 'endTime' | translate }}</label>
                    <input type="time" class="form-control mb-3" id="editDlProgramEndTime" name="editDlProgramEndTime"
                      [(ngModel)]="draft.endTimeStr">

                    <label class="form-label">{{ 'weekDays' | translate }}</label>
                    <div class="dl-weekday-picker dl-weekday-picker--compact">
                      <div class="dl-weekday-picker__presets">
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('weekdays', 'end')">
                          <i class="fas fa-briefcase"></i>
                          <span class="fw-semibold">{{ 'workdays' | translate }}</span>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('weekend', 'end')">
                          <i class="fas fa-bed"></i>
                          <span class="fw-semibold">{{ 'weekend' | translate }}</span>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                          (click)="setQuickPreset('allDays', 'end')">
                          <i class="fas fa-calendar"></i>
                          <span class="fw-semibold">{{ 'allDays' | translate }}</span>
                        </button>
                      </div>
                      <div class="dl-weekday-picker__days">
                        <button *ngFor="let day of daysOfWeek" type="button"
                          class="btn rounded-circle d-inline-flex align-items-center justify-content-center p-0 dl-day-btn"
                          [ngClass]="isDaySelected(draft.cycleEndDaymask, day.value) ? 'btn-secondary' : 'btn-outline-secondary'"
                          [attr.title]="getDayLabel(day.index)" (click)="toggleCycleEndDay(draft, day.value)">
                          <span class="fw-semibold">{{ day.short }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="border rounded-3 p-3">
                  <div class="fw-semibold text-muted small mb-3">{{ 'programKind_cycle' | translate }}</div>
                  <div class="row g-3">
                    <div class="col-12 col-md-6">
                      <label class="form-label" for="editDlProgramOnSeconds">{{ 'programCycleOn' | translate }} {{ 'inSeconds' | translate }}</label>
                      <input type="number" min="1" class="form-control" id="editDlProgramOnSeconds"
                        name="editDlProgramOnSeconds" [(ngModel)]="draft.cycleOnSeconds">
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label" for="editDlProgramOffSeconds">{{ 'programCycleOff' | translate }} {{ 'inSeconds' | translate }}</label>
                      <input type="number" min="1" class="form-control" id="editDlProgramOffSeconds"
                        name="editDlProgramOffSeconds" [(ngModel)]="draft.cycleOffSeconds">
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <div class="w-100 d-flex justify-content-end gap-2">
          <button *ngIf="newProgram" type="button" class="btn btn-outline-secondary" (click)="cancelNewProgram()"
            data-bs-dismiss="modal">{{ 'cancel' | translate }}</button>
          <button *ngIf="!newProgram" type="button" class="btn btn-outline-secondary"
            data-bs-dismiss="modal">{{ 'cancel' | translate }}</button>
          <button type="button" class="btn btn-primary" (click)="saveEditProgram()" data-bs-dismiss="modal">
            {{ 'tourConnectivitySaveTitle' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
